import script from "./CompanyNotesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyNotesPanel.vue?vue&type=script&setup=true&lang=js"

import "./CompanyNotesPanel.vue?vue&type=style&index=0&id=44b3483c&lang=scss"

const __exports__ = script;

export default __exports__